const GitHub = () => {
  return <h1>GitHub</h1>;
};
export default GitHub;
